// extracted by mini-css-extract-plugin
module.exports = {"box":"avatar_box__2e3li","image":"avatar_image__2zr1N"};